import axios from "../axios";
import _get from "lodash/get";
import * as TYPES from "./invoiceActionTypes";

export const setInvoices = value => ({
    type: TYPES.CUSTOMERS,
    value
});

export function getInvoiceCount(params = {}) {
    return async (dispatch, getState) => {
        const BASE_URL = _get(getState(), "appData.BASE_URL");
        const accountId = _get(getState(), "authData.accountId");

        try {
            const _response = await axios({
                url: `${BASE_URL}/secure/${accountId}/invoice/count`,
                method: "get",
                params
            });

            const response = _get(_response, "data", {});
            return response;
        } catch (error) {
            const message = _get(error, "response.data.errors[0].message");
            return { error: true, message };
        }
    };
}

export function getInvoices(params = {}) {
    return async (dispatch, getState) => {
        const BASE_URL = _get(getState(), "appData.BASE_URL");
        const accountId = _get(getState(), "authData.accountId");
        try {
            const _response = await axios({
                url: `${BASE_URL}/secure/${accountId}/invoice`,
                method: "get",
                params
            });

            const response = _get(_response, "data", []);

            dispatch(setInvoices(response));
            return response;
        } catch (error) {
            const message = _get(error, "response.data.errors[0].message");
            return { error: true, message };
        }
    };
}

export function createInvoice(data) {
    return async (dispatch, getState) => {
        const BASE_URL = _get(getState(), "appData.BASE_URL");
        const accountId = _get(getState(), "authData.accountId");
        try {
            const response = await axios({
                url: `${BASE_URL}/secure/${accountId}/invoice`,
                timeout: 20000,
                method: "post",
                data
            });
            const _response = _get(response, "data", {});

            return _response;
        } catch (error) {
            const message = _get(error, "response.data.errors[0].message");
            return { error: true, message };
        }
    };
}

export function updateInvoice(data) {
    return async (dispatch, getState) => {
        const BASE_URL = _get(getState(), "appData.BASE_URL");
        const accountId = _get(getState(), "authData.accountId");
        try {
            const response = await axios({
                url: `${BASE_URL}/secure/${accountId}/invoice`,
                timeout: 20000,
                method: "put",
                data
            });
            const _response = _get(response, "data", {});

            return _response;
        } catch (error) {
            const message = _get(error, "response.data.errors[0].message");
            return { error: true, message };
        }
    };
}

export function getInvoice(id) {
    return async (dispatch, getState) => {
        const BASE_URL = _get(getState(), "appData.BASE_URL");
        const accountId = _get(getState(), "authData.accountId");
        try {
            const response = await axios({
                url: `${BASE_URL}/secure/${accountId}/invoice/${id}`,
                timeout: 20000,
                method: "get"
            });
            const _response = _get(response, "data", {});

            return _response;
        } catch (error) {
            const message = _get(error, "response.data.errors[0].message");
            return { error: true, message };
        }
    };
}
